import { LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import { API_HOST_USERS, API_HOST_EXPERTS_APPLY, API_HOST_REFDATA } from "../config";
import { BusinessService } from "./BusinessService";
import { DummyService } from "./DummyService";
import exampleLookups from "./json/exampleLookups.json";
import { CommissionsService } from "./CommissionsService";
import { ExpertsService } from "./ExpertsService";
import { CommissioningCategoriesService } from "./CommissioningCategoriesService";
import { CommissioningTeamService } from "./CommissioningTeamService";
import { AssignableManagersService } from "./AssignableManagersService";

export const commissionsService = new CommissionsService(API_HOST_EXPERTS_APPLY);
export const assignableManagersService = new AssignableManagersService(API_HOST_USERS);
export const dummyService = new DummyService(API_HOST_USERS);
export const businessService = new BusinessService(API_HOST_USERS);
export const expertsService = new ExpertsService(API_HOST_EXPERTS_APPLY);
export const commissioningCategoriesService = new CommissioningCategoriesService(API_HOST_REFDATA);
export const commissioningTeamService = new CommissioningTeamService(API_HOST_REFDATA);
export const exampleLookupService = new LocalLookupService(exampleLookups);
